import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '@/services/api'

// Async thunks
export const fetchSubscription = createAsyncThunk(
  'subscription/fetchSubscription',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/subscriptions/current')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch subscription')
    }
  }
)

export const fetchPlans = createAsyncThunk(
  'subscription/fetchPlans',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/subscriptions/plans')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch plans')
    }
  }
)

export const upgradePlan = createAsyncThunk(
  'subscription/upgradePlan',
  async (plan, { rejectWithValue }) => {
    try {
      const response = await api.post('/subscriptions/upgrade', { plan })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to upgrade plan')
    }
  }
)

export const fetchUsage = createAsyncThunk(
  'subscription/fetchUsage',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/subscriptions/usage')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch usage')
    }
  }
)

const initialState = {
  currentPlan: null,
  plans: [],
  usage: null,
  modules: [],
  loading: false,
  error: null,
}

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    clearSubscriptionError: (state) => {
      state.error = null
    },
    resetSubscription: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Fetch Subscription
      .addCase(fetchSubscription.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSubscription.fulfilled, (state, action) => {
        state.loading = false
        state.currentPlan = action.payload.data
        state.modules = action.payload.data.modules || []
      })
      .addCase(fetchSubscription.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Fetch Plans
      .addCase(fetchPlans.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.loading = false
        state.plans = action.payload.data
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Upgrade Plan
      .addCase(upgradePlan.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(upgradePlan.fulfilled, (state, action) => {
        state.loading = false
        state.currentPlan = action.payload.data
        state.modules = action.payload.data.modules || []
      })
      .addCase(upgradePlan.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Fetch Usage
      .addCase(fetchUsage.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUsage.fulfilled, (state, action) => {
        state.loading = false
        state.usage = action.payload.data
      })
      .addCase(fetchUsage.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { clearSubscriptionError, resetSubscription } = subscriptionSlice.actions
export default subscriptionSlice.reducer
